import { useAppContext } from '@at/sauron-platform-core';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SCRIPTS } from './scripts.js';
export const getEnabledScripts = (disabledScripts, scripts = SCRIPTS) => {
    return Object.keys(scripts)
        .filter((id) => !disabledScripts.includes(id))
        .filter((id) => scripts[id].enabled !== false)
        .map((id) => scripts[id]);
};
export const PlatformScripts = ({ disabledScripts = [] }) => {
    const enabledScripts = getEnabledScripts(disabledScripts);
    const { config, ssrMode } = useAppContext();
    if (ssrMode || !enabledScripts.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null, enabledScripts.map(({ id, url, embeddedJs, defer = true, async = true }, i) => {
            if (url) {
                return React.createElement("script", { key: i, id: id, src: url, defer: defer, async: async });
            }
            if (embeddedJs) {
                return (React.createElement("script", { key: i, id: id, defer: defer, async: async }, embeddedJs(config)));
            }
            return null;
        }))));
};
export const withScripts = (WrappedComponent, disabledScripts) => {
    const ComponentWithScripts = (props) => (React.createElement(React.Fragment, null,
        React.createElement(PlatformScripts, { disabledScripts: disabledScripts }),
        React.createElement(WrappedComponent, Object.assign({}, props))));
    ComponentWithScripts.displayName = 'WithScripts';
    return ComponentWithScripts;
};
